import { empApi } from "./client";

// Danh sách CTV của tôi -> { items, pagination }
export const getMyRelativeListApi = (params) =>
  empApi.get("/relativeRegisterForm/app/myRelative", params);

// Danh sách phiếu đăng ký CTV -> { items, pagination }
export const getRelativeRegisterFormListApi = (params) =>
  empApi.get("/relativeRegisterForm/app", params);

// Chi tiết phiếu đăng ký CTV
export const getRelativeRegisterFormByIdApi = (id) =>
  empApi.get(`/relativeRegisterForm/app/${id}`);

// Tạo phiếu đăng ký CTV -> body { type: "CREATE", relativeInfo: {...} }
export const createRelativeRegisterFormApi = (body) =>
  empApi.post("/relativeRegisterForm/app", body);

// Cập nhật phiếu đăng ký CTV
export const updateRelativeRegisterFormApi = (id, body) =>
  empApi.put(`/relativeRegisterForm/app/${id}`, body);
